import { create } from 'zustand'
import type { Notificacao } from '../services/notificacaoService'

interface NotificationState {
  notificacoes: Notificacao[]
  naoLidas: number
  
  // Ações
  addNotification: (notification: Notificacao) => void
  setNotificacoes: (notificacoes: Notificacao[]) => void
  setNaoLidas: (count: number) => void
  marcarComoLidaLocal: (id: string) => void
  marcarTodasLidasLocal: () => void
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notificacoes: [],
  naoLidas: 0,
  
  addNotification: (notification) => set((state) => ({
    notificacoes: [notification, ...state.notificacoes],
    naoLidas: state.naoLidas + 1,
  })),
  
  setNotificacoes: (notificacoes) => set({ notificacoes }),
  
  setNaoLidas: (count) => set({ naoLidas: count }),
  
  marcarComoLidaLocal: (id) => set((state) => ({
    notificacoes: state.notificacoes.map(n => 
      n.id === id ? { ...n, lida: true } : n
    ),
    naoLidas: Math.max(0, state.naoLidas - 1),
  })),
  
  marcarTodasLidasLocal: () => set((state) => ({
    notificacoes: state.notificacoes.map(n => ({ ...n, lida: true })),
    naoLidas: 0,
  })),
}))
